import React from "react";
import { motion } from "framer-motion";
import {
  FiCheckCircle,
  FiXCircle,
  FiMinusCircle,
  FiUser,
  FiClock,
  FiMessageSquare,
  FiFileText,
} from "react-icons/fi";

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.3, ease: "easeOut" } },
};

const ModActionLogItem = ({ action }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getActionConfig = (actionType) => {
    if (actionType === "approve") {
      return {
        icon: FiCheckCircle,
        label: "Approved",
        color: "#10b981",
        bgColor: "rgba(16, 185, 129, 0.1)",
        borderColor: "rgba(16, 185, 129, 0.3)",
      };
    }
    if (actionType === "remove") {
      return {
        icon: FiXCircle,
        label: "Removed",
        color: "#ef4444",
        bgColor: "rgba(239, 68, 68, 0.1)",
        borderColor: "rgba(239, 68, 68, 0.3)",
      };
    }
    return {
      icon: FiMinusCircle,
      label: "Dismissed",
      color: "#64748b",
      bgColor: "rgba(100, 116, 139, 0.1)",
      borderColor: "rgba(100, 116, 139, 0.3)",
    };
  };

  const getContentTypeIcon = () => {
    if (action.reportType === "thread") return FiFileText;
    if (action.reportType === "reply") return FiMessageSquare;
    return FiFileText;
  };

  const actionConfig = getActionConfig(action.action);
  const ActionIcon = actionConfig.icon;
  const ContentIcon = getContentTypeIcon();

  return (
    <motion.div className="collab-comm-mod-log-item" variants={itemVariants}>
      <div
        className="collab-comm-mod-log-indicator"
        style={{ backgroundColor: actionConfig.color }}
      />

      <div className="collab-comm-mod-log-content">
        <div className="collab-comm-mod-log-header">
          <div
            className="collab-comm-mod-log-action-badge"
            style={{
              backgroundColor: actionConfig.bgColor,
              borderColor: actionConfig.borderColor,
              color: actionConfig.color,
            }}
          >
            <ActionIcon size={14} />
            <span>{actionConfig.label}</span>
          </div>

          <div className="collab-comm-mod-log-type">
            <ContentIcon size={14} />
            <span>{action.reportType || "content"}</span>
          </div>
        </div>

        <div className="collab-comm-mod-log-details">
          <div className="collab-comm-mod-log-moderator">
            <div className="collab-comm-mod-log-avatar">
              <FiUser size={12} />
            </div>
            <span>
              Moderated by{" "}
              <strong>
                {action.moderator?.name ||
                  action.moderator?.username ||
                  "Unknown"}
              </strong>
            </span>
          </div>

          {action.notes && (
            <div className="collab-comm-mod-log-notes">
              <p>{action.notes}</p>
            </div>
          )}

          <div className="collab-comm-mod-log-timestamp">
            <FiClock size={12} />
            <span>{formatDate(action.createdAt)}</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ModActionLogItem;
